import { render, staticRenderFns } from "./shuibj.vue?vue&type=template&id=e3be1fe8&scoped=true&"
import script from "./shuibj.vue?vue&type=script&lang=js&"
export * from "./shuibj.vue?vue&type=script&lang=js&"
import style0 from "./shuibj.vue?vue&type=style&index=0&id=e3be1fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3be1fe8",
  null
  
)

export default component.exports